import React, { useMemo } from 'react';
import { ReactComponent as WaitResponseIcon } from './../wait-response-icon.svg';
import { ReactComponent as MessageIcon } from './../message-icon.svg';
import { ReactComponent as AddToTeam } from './../add-freelancer-to-team.svg';
import { ReactComponent as AddToOtherTeam } from './../add-freelancer-to-other-team.svg';
import { ReactComponent as HireArrowIcon } from './../hire-icon.svg';
import { useCallback } from 'react';
import classNames from 'classnames';
import { useSelector } from '../../../../hooks/useSelector';

const UnreviewedProposal = ({ unreview, rawPostData, handleOpenAddToTeamPopup }) => {
    const { allUserTeams } = useSelector(state => state.invitePeople);

    const handleOpenAddToTeam = useCallback(
        () => unreview.name && handleOpenAddToTeamPopup(unreview.email),
        [unreview, handleOpenAddToTeamPopup]
    );

    const emailBtnClass = classNames({
        'config-response-btn': true,
        'is-active': !!unreview.email,
    });

    const isUserAssignedToTeam = useMemo(
        () => allUserTeams.find(team => team.invitedUsers.includes(unreview.email)),
        [allUserTeams, unreview]
    );

    const addToTeamClass = classNames({
        'add-to-team-btn': true,
        'add-to-other-team-btn': isUserAssignedToTeam,
        'is-active': !!unreview.name && !!allUserTeams.length,
    });

    return (
        <li className="post__proposal post-proposal__unreviewed">
            <div className="proposal__response-icon-wrap">
                <WaitResponseIcon />
            </div>
            <div className="proposal__response-freelancer-info">
                {unreview?.name && unreview?.position ? (
                    <>
                        <span className="freelancer-name">{unreview.name}</span>
                        <span className="freelancer-post">{unreview.position}</span>
                    </>
                ) : (
                    <span className="freelancer-name">{unreview.email}</span>
                )}
            </div>
            <div className="unreviewed-info">
                <span className="unreviewed-sent-label">Invitation has been sent</span>
                <span className="unreviewed-sent-status">
                    {rawPostData.viewed.filter(viewedUser => viewedUser.email === unreview.email)
                        .length
                        ? 'Read'
                        : 'Unread'}
                </span>
            </div>
            <div className="config-response-btns-wrap">
                <a href={`mailto:${unreview.email}`}>
                    <MessageIcon className={emailBtnClass} />
                </a>
                {isUserAssignedToTeam ? (
                    <AddToOtherTeam onClick={handleOpenAddToTeam} className={addToTeamClass} />
                ) : (
                    <AddToTeam onClick={handleOpenAddToTeam} className={addToTeamClass} />
                )}
            </div>
            <div className="proposal__right-side-group">
                <button className="proposal__hire-button proposal__hire-button-unreviewed">
                    <span>Select</span>
                    <HireArrowIcon />
                </button>
            </div>
        </li>
    );
};

export default UnreviewedProposal;
